import { sortLogChain, fetchEventTime } from '../endorsement-chain/helpers';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const getEndorsementChain = /* @__PURE__ */ __name(async (provider, logChain) => {
  const historyChain = [];
  sortLogChain(logChain);
  let previousBeneficiary = "";
  let previousHolder = "";
  const timestampPromises = logChain.map((log) => fetchEventTime(log.blockNumber, provider));
  const timestamps = await Promise.all(timestampPromises);
  logChain.forEach((log, index) => {
    const timestamp = timestamps[index];
    const transactionDetails = {
      type: log.type,
      transactionHash: log.transactionHash,
      transactionIndex: log.transactionIndex,
      blockNumber: log.blockNumber,
      owner: log.owner || previousBeneficiary,
      holder: log.holder || previousHolder,
      timestamp,
      remark: log?.remark || ""
    };
    if (log.type === "TRANSFER_OWNERS" || log.type === "TRANSFER_BENEFICIARY" || log.type === "TRANSFER_HOLDER" || log.type === "INITIAL") {
      historyChain.push(transactionDetails);
      previousHolder = transactionDetails.holder;
      previousBeneficiary = transactionDetails.owner;
    } else if (log.type === "SURRENDER_ACCEPTED" || log.type === "RETURN_TO_ISSUER_ACCEPTED") {
      previousHolder = "";
      previousBeneficiary = "";
      historyChain.push(transactionDetails);
    } else if (log.type === "SURRENDERED" || log.type === "SURRENDER_REJECTED" || log.type === "RETURNED_TO_ISSUER" || log.type === "RETURN_TO_ISSUER_REJECTED") {
      historyChain.push(transactionDetails);
    } else {
      historyChain.push(transactionDetails);
    }
  });
  return historyChain;
}, "getEndorsementChain");

export { getEndorsementChain };
